import './selectPatientComponent.scss';
import React, {useCallback, useEffect, useState} from 'react';
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import CommonService from "../../../../shared/services/common.service";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import AutoCompleteDropdownComponent
    from "../../../../shared/components/core/auto-complete-dropdown/autoCompleteDropdownComponent";
import {APIConfig, ImageConfig} from "../../../../constants";
import {ITableColumn} from "../../../../shared/models/table.model";
import RadioButtonComponent from "../../../../shared/components/core/radio-button/radioButtonComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {IPatient} from "../../../../shared/models/patient.model";
import Grid from "@mui/material/Grid";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import OtpComponent from "../../../../shared/components/otp/otpComponent";
import TimerComponent from "../../../../shared/components/timer/timerComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import {
    setFacilityDetailsForLocation,
    setLocationDetailsForTestOrder
} from "../../../../store/actions/facilityAndLocation.action";
import HeadingComponent from "../../../../shared/components/heading/headingComponent";
import SearchComponent from "../../../../shared/components/search/SearchComponent";
import _ from "lodash";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import WarningIcon from "@mui/icons-material/Warning";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../../shared/services/common.service";
import {useNavigate} from "react-router-dom";
// import ConsentCollectionComponent from '../../../../shared/components/consent-collection/ConsentCollectionComponent';

const OTP_LENGTH = 6;
const OTP_WAIT_TIME = 90;

export interface SelectFacilityAndLocationProps {
    facilityDetailsForTestOrder?: any;
    locationDetailsForTestOrder?: any;
    next: Function;
    cancel: Function;
}

const FiltersInitialState: any = {
    search: '',
    limit: 25,
}

const SelectPatientComponent = (props: SelectFacilityAndLocationProps) => {

        const navigate = useNavigate();
        const {next, facilityDetailsForTestOrder, cancel, locationDetailsForTestOrder} = props;

        // const [isConsentCollectionModalOpen, setIsConsentCollectionModalOpen] = useState<boolean>(false);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);
        const loggedInUserFacilityDetails = currentUser?.facilityDetails
        const loggedInUserLocationDetails = currentUser?.locationDetails

        const [facilityList, setFacilityList] = useState<any>([]);
        const [isFacilityListLoading, setIsFacilityListLoading] = useState<boolean>(false);
        const [isFacilityListLoaded, setIsFacilityListLoaded] = useState<boolean>(false);
        const [isFacilityListLoadingFailed, setIsFacilityListLoadingFailed] = useState<boolean>(false);

        const [locationList, setLocationList] = useState<any>([]);
        const [isLocationListLoaded, setIsLocationListLoaded] = useState<boolean>(false);
        const [isLocationListLoading, setIsLocationListLoading] = useState<boolean>(false);
        const [isLocationListLoadingFailed, setIsLocationListLoadingFailed] = useState<boolean>(false);

        const [facilityDetails, setFacilityDetails] = useState<any>(null);
        const [locationDetails, setLocationDetails] = useState<any>(null);
        const [isTestOrderCreatedInProgress, setTestOrderCreatedInProgress] = useState<boolean>(false);

        const [patientID, setPatientID] = useState<number | undefined>(undefined);

        const [buttonContent, setButtonContent] = useState<string>('Proceed');
        const [showOTPDrawer, setShowOTPDrawer] = useState<boolean>(false);

        const [patientDetails, setPatientDetails] = useState<any>(undefined);
        const [noOfSecondsLeftToRequestForNewOTP, setNoOfSecondsLeftToRequestForNewOTP] = useState(0);
        const [isOTPLoaded, setIsOTPLoaded] = useState<boolean>(false);
        const [isOTPLoading, setIsOTPLoading] = useState<boolean>(false);
        const [otp, setOtp] = useState<string>();
        const [isOtpSubmitting, setIsOtpSubmitting] = useState<any>(false);
        const [intervalSub, setIntervalSub] = useState<any>(null);
        const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
        const [isOtpRequired, setIsOtpRequired] = useState<boolean>(false)

        const dispatch = useDispatch();

        const columns: ITableColumn[] = [
            {
                id: 'check', label: '', width: '70', fixed: "left", align: "center",
                content: (item: any) => (
                    <RadioButtonComponent
                        name={"help"}
                        checked={patientID === item.id}
                        value={item.id}
                        onUpdate={() => selectPatient(item)}
                    />
                )
            },
            {
                id: 'firstName', label: 'First Name', isDefaultColumn: true,
                content: (item: IPatient) => (
                    <React.Fragment>
                        {
                            item ? <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.firstName)} <br/>
                            </> : <> - </>
                        }
                    </React.Fragment>
                )
            },
            {
                id: 'lastName', label: 'Last Name', isDefaultColumn: true,
                content: (item: IPatient) => (
                    <React.Fragment>
                        {
                            item ? <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.lastName)} <br/>
                            </> : <> - </>
                        }
                    </React.Fragment>
                )
            },
            {
                id: 'dateOfBirth', label: 'Date of Birth', align: "center",
                isDefaultColumn: true,
                content: (item: IPatient) => (
                    <React.Fragment>
                        {
                            item ?
                                <>
                                    {item.isOtpRequired ? "*****" : commonService.formatDate(item?.dateOfBirth)}
                                </> : <> - </>
                        }
                    </React.Fragment>
                )
            },
            {
                id: 'gender', label: 'Gender', isDefaultColumn: true, align: "center",
                content: (item: IPatient) => (
                    <React.Fragment>
                        {
                            item ? <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.gender)} <br/>
                            </> : <> - </>
                        }
                    </React.Fragment>
                )
            },
            {
                id: 'mobileNumber', label: 'Phone Number', isDefaultColumn: true, fixed: 'right', align: "center",
                content: (item: IPatient) => (
                    <React.Fragment>
                        {
                            item ? <>
                                {item.isOtpRequired ? "*****" : CommonService.getMaskedMobileNumber(item?.mobileNumber)}
                                <br/>
                            </> : <> - </>
                        }
                    </React.Fragment>
                )
            },
        ];

        const getFacilityList = useCallback(() => {
            const payload = {isActive: true};
            setIsFacilityListLoading(true);
            setIsFacilityListLoadingFailed(false);
            setIsFacilityListLoaded(false);
            let facilityList: any = [];
            CommonService._facility.getFacilityListLite(payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        facilityList = response.data;
                    }
                    setFacilityList(facilityList);
                    setIsFacilityListLoading(false);
                    setIsFacilityListLoadingFailed(false);
                    setIsFacilityListLoaded(true);
                })
                .catch((error: any) => {
                    setIsFacilityListLoading(false);
                    setIsFacilityListLoaded(false);
                    setIsFacilityListLoadingFailed(true);
                });
        }, []);

        const getLocationList = useCallback((facilityID: any) => {
            const payload = {facilityId: facilityID, isActive: true, isLabVerificationReq: true};
            // if isLabVerificationReq is true then in the location list lite the location linked to lab = sendLab will not get included
            setIsLocationListLoading(true);
            setIsLocationListLoadingFailed(false);
            setIsLocationListLoaded(false);
            let locationList: any = [];
            CommonService._location.getLocationListLite(payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        locationList = response.data;
                    }
                    setLocationList(locationList);
                    setIsLocationListLoading(false);
                    setIsLocationListLoadingFailed(false);
                    setIsLocationListLoaded(true);
                })
                .catch((error: any) => {
                    setIsLocationListLoading(false);
                    setIsLocationListLoaded(false);
                    setIsLocationListLoadingFailed(true);
                });
        }, []);

        const selectPatient = useCallback((item: any) => {
            setPatientID(item.id);
            setPatientDetails(item);
            setButtonContent('Proceed');
            setIsOtpRequired(false)
            if (item.isOtpRequired) {
                setButtonContent('Request OTP');
                setIsOtpRequired(true);
            }
        }, [setPatientID]);

        const runTimer = useCallback(() => {
            let setIntervalVal: any = null;
            if (intervalSub) {
                clearInterval(intervalSub);
            }
            setNoOfSecondsLeftToRequestForNewOTP(OTP_WAIT_TIME);
            setIntervalVal = setInterval(() => {
                setNoOfSecondsLeftToRequestForNewOTP((oldState: any) => {
                    if (oldState > 0) {
                        return oldState - 1;
                    } else {
                        clearInterval(setIntervalVal);
                        return 0;
                    }
                });
            }, 1000);
            setIntervalSub(setIntervalVal);
        }, [intervalSub]);

        const sendOTPEmail = useCallback(() => {
            setIsOTPLoaded(false);
            setIsOTPLoading(true);
            const payload = {};
            CommonService._patient.sendOTPtoPatient(patientDetails?.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    runTimer();
                    setIsOTPLoaded(true);
                    setIsOTPLoading(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || "Failed to send OTP", "error");
                    setIsOTPLoaded(false);
                    setIsOTPLoading(false);
                });
        }, [patientDetails, runTimer]);

        const handleEmailResend = useCallback(() => {
            if (noOfSecondsLeftToRequestForNewOTP > 0) {
                CommonService._alert.showToast(`Please request for new OTP after ${noOfSecondsLeftToRequestForNewOTP} seconds`, "info");
                return;
            }
            setOtp('');
            sendOTPEmail();
        }, [noOfSecondsLeftToRequestForNewOTP, sendOTPEmail]);

        const closeOtpDrawer = useCallback(() => {
            setOtp('');
            setShowOTPDrawer(false);
            if (intervalSub) {
                clearInterval(intervalSub);
            }
        }, [intervalSub]);


        // const handleTakeConsent = useCallback(() => {
        //     setIsConsentCollectionModalOpen(true);
        // }, []);

        // flow changed before callback expecting isPatientConsentSigned?: boolean, now we are not showing the consent popup modal to collect consent
        const submitSelectedPatient = useCallback(() => {
            const payload = {
                facilityId: facilityDetails.id,
                locationId: locationDetails.id,
                patientId: patientID,
                // isPatientConsentSigned,
            };
            setTestOrderCreatedInProgress(true);
            CommonService._testOrder.createNewTestOrder(payload)
                .then((response: IAPIResponseType<any>) => {
                    setTestOrderCreatedInProgress(false);
                    next(response?.data.id);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || "Failed to create new test order", "error");
                    setTestOrderCreatedInProgress(false);
                });
        }, [facilityDetails, locationDetails, patientID, next])

        // flow changed before callback expecting isPatientConsentSigned?: boolean, now we are not showing the consent popup modal to collect consent
        const handlePatientConsentCollection = useCallback(() => {
            submitSelectedPatient();
        }, [submitSelectedPatient]);

        const handleCreatePatientPopup = useCallback(() => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to create Test Order for this patient?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Continue",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            }).then(() => {
                // handleTakeConsent();
                handlePatientConsentCollection();
            })
                .catch(() => {
                });
        }, [handlePatientConsentCollection]);


        const onVerifyOtp = useCallback(() => {
            setIsOtpSubmitting(true);
            const payload = {
                'otp': otp,
                facilityId: facilityDetails.id,
                locationId: locationDetails.id
            }
            CommonService._patient.verifyPhoneNumberOtp(patientDetails?.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsOtpSubmitting(false);
                    CommonService._alert.showToast(response.message || "OTP verification completed successfully", "success");
                    setShowOTPDrawer(false);
                    handleCreatePatientPopup();
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error.error, "error");
                    setIsOtpSubmitting(false);
                })
        }, [otp, patientDetails, facilityDetails, locationDetails, handleCreatePatientPopup]);

        useEffect(() => {
            if (loggedInUserFacilityDetails) {
                setFacilityDetails(loggedInUserFacilityDetails);
            } else {
                getFacilityList();
            }
        }, [getFacilityList, loggedInUserFacilityDetails]);

        useEffect(() => {
            if (loggedInUserLocationDetails) {
                setFacilityDetails(loggedInUserFacilityDetails);
                setLocationDetails(loggedInUserLocationDetails);
            } else {
                if (loggedInUserFacilityDetails) {
                    getLocationList(loggedInUserFacilityDetails?.id);
                }
            }
        }, [getLocationList, loggedInUserFacilityDetails, loggedInUserLocationDetails]);

        useEffect(() => {
            if (facilityDetailsForTestOrder && Object.keys(facilityDetailsForTestOrder).length !== 0 && locationDetailsForTestOrder && Object.keys(locationDetailsForTestOrder).length !== 0) {
                setFacilityDetails(facilityDetailsForTestOrder);
                setLocationDetails(locationDetailsForTestOrder);
                getLocationList(facilityDetailsForTestOrder?.id);
                dispatch(setFacilityDetailsForLocation({}))
                dispatch(setLocationDetailsForTestOrder({}));
            }
        }, [locationDetailsForTestOrder, facilityDetailsForTestOrder, dispatch, getLocationList]);

        const onFacilitySelection = useCallback((value: any) => {
            setIsOtpRequired(false);
            if (value?.id) {
                setFacilityDetails(value);
                getLocationList(value?.id);
                setLocationDetails(undefined);
                setPatientID(undefined);
            } else {
                setFacilityDetails(undefined);
                setLocationDetails(undefined);
                setPatientID(undefined);
            }
        }, [setFacilityDetails, getLocationList]);

        const onLocationSelection = useCallback((value: any) => {
            setIsOtpRequired(false);
            if (value?.id) {
                setLocationDetails(value);
                setPatientID(undefined);
            } else {
                setLocationDetails(undefined);
                setPatientID(undefined);
            }
        }, [setLocationDetails]);

        const showOtpDrawer = useCallback(() => {
            sendOTPEmail();
            setShowOTPDrawer(true);
        }, [sendOTPEmail]);

        const handleSearch = useCallback((value: string) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: value,
            }));
        }, []);

        useEffect(() => {
            if (queryParamData) {
                const data: any = {
                    search: queryParamData.search || '',
                    facilityId: facilityDetails?.id,
                    locationId: locationDetails?.id,
                    purpose: 'testOrderCreation'
                };
                setFilterData((prevState: any) => ({
                    ...prevState, ...data
                }));
            }
        }, [queryParamData, facilityDetails, locationDetails]);

        const handleTestOrderCreation = useCallback(() => {
            if (buttonContent === 'Proceed') {
                // handleTakeConsent();
                handlePatientConsentCollection();
            } else {
                showOtpDrawer();
            }
        }, [buttonContent, showOtpDrawer,handlePatientConsentCollection])

        const handleRedirectPatientAddRoute = useCallback(() => {
            navigate(CommonService._routeConfig.PatientAddRoute() + CommonService.setUrlSearchParams({
                returnUrl: "/test-order-create",
                facilityId: facilityDetails?.id,
                locationId: locationDetails?.id,
            }));
        }, [navigate, facilityDetails, locationDetails])


        return (
            <div className="select-patient-screen t-form-screen screen">
                <FormTitleWithNavigationBack
                    title={'Select Patient'}
                    tooltipData={"Search patient by First Name, Last Name, or Mobile Number. Be certain that you choose the right one."}
                />
                <div className="t-form">
                    <form>
                        <div className="t-form-controls-wrapper">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <AutoCompleteDropdownComponent
                                        name={'facility'}
                                        fullWidth={true}
                                        label={"Facility Name"}
                                        required={true}
                                        multiple={false}
                                        data={facilityList}
                                        valueKey={"id"}
                                        disabled={loggedInUserFacilityDetails}
                                        isDataLoaded={!loggedInUserFacilityDetails && isFacilityListLoaded}
                                        isDataLoading={!loggedInUserFacilityDetails && isFacilityListLoading}
                                        isDataLoadingFailed={!loggedInUserFacilityDetails && isFacilityListLoadingFailed}
                                        value={facilityDetails}
                                        placeholder={"Select Facility Name"}
                                        getOptionLabel={(option => (option.name) || '')}
                                        onSelectUpdate={(value: any) => {
                                            onFacilitySelection(value);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <AutoCompleteDropdownComponent
                                        name={'location'}
                                        fullWidth={true}
                                        label={"Location Name"}
                                        required={true}
                                        multiple={false}
                                        disabled={!facilityDetails || loggedInUserLocationDetails}
                                        data={locationList}
                                        valueKey={"id"}
                                        isDataLoaded={!loggedInUserLocationDetails && isLocationListLoaded}
                                        isDataLoading={!loggedInUserLocationDetails && isLocationListLoading}
                                        isDataLoadingFailed={!loggedInUserLocationDetails && isLocationListLoadingFailed}
                                        value={locationDetails}
                                        placeholder={"Select Location Name"}
                                        getOptionLabel={(option => (option.name) || '')}
                                        onSelectUpdate={(value: any) => {
                                            onLocationSelection(value);
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <div className="page-search">
                                <SearchComponent
                                    label={"Search Patient"}
                                    id="search_input"
                                    placeholder={""}
                                    disabled={!facilityDetails || !locationDetails}
                                    value={filterData.search}
                                    onChange={handleSearch}
                                />
                            </div>
                            {
                                locationDetails && (
                                    <div className="select_patient_wrapper">
                                        <div>Didn’t find the patient?</div>
                                        <div className="create-patient-link"
                                             onClick={handleRedirectPatientAddRoute}
                                        >Create Patient
                                        </div>
                                    </div>
                                )
                            }
                            {
                                locationDetails && <div className={'patient-list-table-wrapper'}>
                                    <TableWrapperV2Component
                                        isPaginated={false}
                                        isHoverable={true}
                                        columns={columns}
                                        url={APIConfig.PATIENT_LIST.URL}
                                        method={APIConfig.PATIENT_LIST.METHOD}
                                        extraPayload={filterData}
                                    />
                                </div>
                            }
                            {isOtpRequired && <div className="d-flex align-items-center mrg-top-10">
                                <div><WarningIcon color={"primary"}/></div>
                                <div className="patient-confirmation-test mrg-left-10">
                                    The selected patient does not exist in facility database. Please request
                                    an
                                    OTP
                                    to
                                    process with this patient’s test order.
                                </div>
                            </div>}

                        </div>
                        <div className="form-action-section">
                            <ButtonComponent
                                type="button"
                                variant={"outlined"}
                                fullWidth={true}
                                disabled={isTestOrderCreatedInProgress}
                                handleClick={cancel}
                            >
                                Cancel
                            </ButtonComponent>
                            <ButtonComponent
                                type="button"
                                variant={"contained"}
                                fullWidth={true}
                                disabled={!patientID}
                                handleClick={() => handleTestOrderCreation()}
                                isLoading={isTestOrderCreatedInProgress}
                            >
                                {buttonContent}
                            </ButtonComponent>
                        </div>
                    </form>
                </div>

                <DrawerComponent open={showOTPDrawer}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 className={"drawer-wrapper"}
                                 onClose={closeOtpDrawer}
                >
                    <div className="otp-verification-form otp-drawer-container screen t-form-screen">
                        <div className="drawer-sub-header horizontal-vertical-center-align">
                            <HeadingComponent title={"OTP Verification"}/>
                        </div>
                        <div className="t-form t-form-drawer">
                            <div className="no-form">
                                <div className="t-form-controls-wrapper">
                                    <div className="otp-drawer-description">Please enter the OTP we sent
                                        on&nbsp; <b>{CommonService.getMaskedMobileNumber(patientDetails?.mobileNumber)}</b>
                                    </div>
                                    {
                                        isOTPLoading && <div className="spinner-loading-wrapper">
                                            <LottieFileGenarationComponent
                                                loop={true}
                                                autoplay={true}
                                                animationData={ImageConfig.LoadingLottieFile}/>
                                            <div className="mrg-top-10">OTP is generating please wait</div>
                                        </div>
                                    }
                                    {isOTPLoaded && <>
                                        <OtpComponent
                                            isInputNum={true}
                                            numInputs={OTP_LENGTH}
                                            onUpdate={(otp: any) => {
                                                setOtp(otp);
                                            }}
                                        />
                                        <div className="d-flex justify-content-end mrg-top-20">
                                            {noOfSecondsLeftToRequestForNewOTP ?
                                                <>
                                                    <span className="mrg-right-5">Resend OTP in</span>
                                                    <TimerComponent
                                                        noOfSeconds={noOfSecondsLeftToRequestForNewOTP}/>
                                                </> : <>&nbsp;</>
                                            }
                                            {!noOfSecondsLeftToRequestForNewOTP &&
                                                <span
                                                    className={"email-resend-link " + (noOfSecondsLeftToRequestForNewOTP ? 'disabled' : '')}
                                                    id="email_resend_link"
                                                    onClick={() => handleEmailResend()}>Resend OTP</span>
                                            }
                                        </div>
                                    </>
                                    }
                                </div>
                                {isOTPLoaded &&
                                    <div className="drawer-actions form-action-section">
                                        <ButtonComponent
                                            type={"button"}
                                            color={'primary'}
                                            fullWidth={true}
                                            disabled={!otp}
                                            variant={"contained"}
                                            isLoading={isOtpSubmitting}
                                            handleClick={onVerifyOtp}
                                        >
                                            Verify
                                        </ButtonComponent>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </DrawerComponent>
                {/* <ConsentCollectionComponent
                    isOpen={isConsentCollectionModalOpen}
                    onClose={() => setIsConsentCollectionModalOpen(false)}
                    onConfirm={handlePatientConsentCollection}
                    patientName={`${patientDetails?.firstName || ''} ${patientDetails?.lastName || ''}`}
                /> */}
            </div>
        )


    }
;

export default SelectPatientComponent;
